<template>
    <div class="bg-white text-a-brown-502314 p-3 rounded-xl" v-if="isLoaded">
        <div class="flex w-full pb-3">
            <div class="flex" v-if="delivery.deliveryMethod == 'Delivery'">
                <img class="-mt-6 -ml-5" src="@/assets/shopping_cart/delivery.svg"/>
                <div class="font-bold ml-2 lg:text-18">Delivery to</div>
            </div>
            <div class="flex" v-else>
                <img src="@/assets/icon/ic-bag-brown.svg"/>
                <div class="font-bold ml-2">{{lbl.shoppingcart.delivery_method.pickup_at}}</div>
            </div>
            <div class="mr-0 ml-auto my-auto cursor-pointer">
                <img @click="gotoDeliveryMethod()" src="@/assets/icon/ic-edit-brown.svg" />
            </div>
        </div>
        <div class="p-2 rounded-xl bg-a-egg-f5ebdc text-14 lg:text-16">
            <div class="lg:flex">
                <div class="address"  v-if="delivery.deliveryMethod == 'Delivery'">{{getAddress()}}</div>
                <div class="address"  v-else>{{getNameBranch()}}</div>
                <div v-if="delivery.deliverTime"
                    class="pt-1 lg:pt-0"  ><span class="text-a-brown-9f8273">{{lbl.shoppingcart.delivery_method.time}} : </span>{{getSpecificTime()}}</div>
                <div v-else
                    class="pt-1 lg:pt-0" ><span class="text-a-brown-9f8273">{{lbl.shoppingcart.delivery_method.time}} : </span>{{lbl.shoppingcart.delivery_method.now}}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
//helper
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import DeliveryMixin from '@/mixin/DeliveryMixin.js';
export default {
    name: "CartAddress",
    // inject: ['DeliveryStore'],
    mixins: [LocaleMixin,AuthStatusMixin,DeliveryMixin],
    data: function() {
        return {
            isLoaded: false
        };
    },
    
    created: function() {
    },
    methods: {
        onAccountInit: function() {
            this.isLoaded = true;
            
            console.log("Account-delivery",this.delivery);
        },
        onDeliveryUpdate: function() {
            this.$emit('onLoaded');
            console.log("onDeliveryUpdate",this.delivery);
        },
        getNameBranch: function() {
            if (this.localeCode == 1033) {
                return this.delivery.location.nameEN
            } else {
                return this.delivery.location.name
            }
        },
        getAddress: function () {
            var address = "";
            if (this.delivery.address) {
                if (this.delivery.address.number) {
                    address += this.delivery.address.number + " ";
                }
                if (this.delivery.address.soi) {
                    address += this.delivery.address.soi + " ";
                }
                if (this.delivery.address.subDistrictName) {
                    address += this.delivery.address.subDistrictName + " ";
                }
                if (this.delivery.address.districtName) {
                    address += this.delivery.address.districtName + " ";
                }

                if (this.delivery.address.zipcode) {
                    address += this.delivery.address.zipcode;
                }
            }
            return address;
        },
        getData: function() {
            console.log("getData-delivery",this.delivery);
            return this.delivery;
        },
        gotoDeliveryMethod: function () {
            this.$emit('gotoDeliveryMethod');
        },
        getSpecificTime: function () {
            //return DatetimeHelper.getDatetimeFullFormat(this.delivery.deliverTime)
            return DatetimeHelper.timestampFullFormat(this.delivery.deliverTime) + " | " + DatetimeHelper.timeFormatShort2(this.delivery.deliverTime);
        }
        
    }

}
</script>

<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    .address {
        @extend %ellipsis-1;
        max-width: 560px;
    }
</style>